import {
  INSIGHTS_TYPE,
  InsightsRowAPIResponse,
  formatPercentage,
} from '../shared/utils'
import { formatCurrencyFromCents } from '@/utils/currencyHelpers'
import { Badge, Table, Button } from '@/ui'
import { useIsDeviceWidth, DeviceWidth } from '@/utils/deviceWidthHelpers'
import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'

const ExpenseRowTags = ({
  isTopExpense,
  insightsType,
}: {
  isTopExpense: boolean
  insightsType: INSIGHTS_TYPE
}) => {
  return (
    isTopExpense &&
    insightsType === INSIGHTS_TYPE.EXPENSES && (
      <Badge className="mb-2">Top Expense</Badge>
    )
  )
}

export const InsightsRow = ({
  insightsRow,
  isTopExpense,
  onTransactionsClick,
  insightsType,
}: {
  insightsRow: InsightsRowAPIResponse
  isTopExpense: boolean
  onTransactionsClick: () => void
  insightsType: INSIGHTS_TYPE
}) => {
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)

  const formatTransactionLabel = (count: number): string => {
    if (isMobile) {
      return ''
    }
    if (count === 1) {
      return 'transaction'
    }
    return 'transactions'
  }

  return (
    <Table.Row>
      <Table.Cell>
        {insightsRow.transaction_category_name}
        {isMobile && (
          <ExpenseRowTags
            isTopExpense={isTopExpense}
            insightsType={insightsType}
          />
        )}
      </Table.Cell>
      {!isMobile && (
        <Table.Cell textAlign="right">
          <div className="flex flex-row justify-end items-end gap-2">
            <ExpenseRowTags
              isTopExpense={isTopExpense}
              insightsType={insightsType}
            />
          </div>
        </Table.Cell>
      )}
      {!isMobile && (
        <Table.Cell textAlign="center">
          {formatPercentage(insightsRow.percent_of_total_cents_decimal)}
        </Table.Cell>
      )}
      <Table.Cell textAlign="center">
        <CurrencyFormatLabel
          value={formatCurrencyFromCents(
            insightsRow?.transactions_sum_in_cents
          )}
        />
      </Table.Cell>
      <Table.Cell textAlign="center">
        <Button variant="link" onClick={onTransactionsClick}>
          {insightsRow.transactions_count}{' '}
          {formatTransactionLabel(insightsRow.transactions_count)}
        </Button>
      </Table.Cell>
    </Table.Row>
  )
}
